<template>
  <section>
    <q-table
      style="height: 500px"
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="rows"
      :loading="disable"
      :columns="columns"
      class="q-mt-md tabela-tamanho-fixo"
      row-key="name"
      color="primary"
      dense
      :pagination="pagination"
      :rows-per-page-label="'Linhas Por Página'"
      :rows-per-page-options="[10, 25, 50, 100]"
      :filter="filtrar"
    >
      <template v-slot:top-right>
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filtrar"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>

      <template #body-cell-funcionarioDataRealizacao="props">
        <q-td>
          <span v-if="props.row.funcionarioDataRealizacao">{{
            props.row.funcionarioDataRealizacao.split("-").reverse().join("/")
          }}</span>
        </q-td>
      </template>
      <template #body-cell-grupos="props">
        <q-td>
          <section
            v-for="(grupo, index) in props.row.grupos"
            :key="index"
            class="column"
          >
            <span>
              {{ grupo.nome }}
            </span>
          </section>
        </q-td>
      </template>

      <template #body-cell-funcionarioDataExpiracao="props">
        <q-td>
          <span v-if="props.row.funcionarioDataExpiracao">{{
            props.row.funcionarioDataExpiracao.split("-").reverse().join("/")
          }}</span>
        </q-td>
      </template>
      <template #body-cell-funcionarioPresenca="props">
        <q-td>
          <span v-if="props.row.funcionarioPresenca == 1"> SIM</span>
          <span v-else>NÃO</span>
        </q-td>
      </template>
    </q-table>
  </section>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
const columns = [
  {
    name: "nome",
    label: "Treinamento",
    field: "nome",
    align: "left",
  },
  {
    name: "grupos",
    label: "Produtos Impactados",
    field: "grupos",
    align: "left",
  },
  {
    name: "funcionarioValidade",
    label: "Válido por (dias)",
    field: "funcionarioValidade",
    align: "left",
  },
  {
    name: "funcionarioDataRealizacao",
    label: "Realizado em",
    field: "funcionarioDataRealizacao",
    align: "left",
  },
  {
    name: "funcionarioDataExpiracao",
    label: "Válido até",
    field: "funcionarioDataExpiracao",
    align: "left",
  },
  {
    name: "funcionarioObrigatorio",
    label: "Obrigatório",
    field: "funcionarioObrigatorio",
    align: "left",
  },
  {
    name: "funcionarioPresenca",
    label: "Presença Confirmada?",
    field: "funcionarioPresenca",
    align: "left",
  },
  {
    name: "autenticacao",
    label: "Status",
    field: "autenticacao",
    align: "left",
  },
];
export default {
  setup() {
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
    });
    const rows = ref([]);
    const disable = ref(true);
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();

    const id = route.params.id;

    const getTreinamentos = async () => {
      disable.value = true;

      try {
        let response = await store.dispatch("user/getTreinamentosAssociados", {
          id,
        });

        rows.value = response.data.treinamentos;

        disable.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getTreinamentos);

    const removerGrupo = async (group_id) => {
      try {
        await store.dispatch("user/removerGrupo", {
          id,
          group_id,
        });

        quasar.notify({
          message: "Grupo removido com sucesoo",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getTreinamentos();
      } catch (error) {
        quasar.notify({
          message: "Erro ao remover grupo",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    return {
      columns,
      rows,
      pagination,
      disable,
      getTreinamentos,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      removerGrupo,
      filtrar: ref(""),
    };
  },
};
</script>
